// extracted by mini-css-extract-plugin
module.exports = {"layout":"fhs-brand_layout__JRVBV","brand":"fhs-brand_brand__QJaYU","sector":"fhs-brand_sector__2t5I9"};